
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { comForm } from "@newview/ui";
@Component({
  name: "",
  components: {
    comForm
  },
})
export default class filterClass extends BaseVue {
  @Prop({ default: "select" }) type!: String; //
  @Prop({ default: [] }) options!: any; 
  @Prop({ default: true }) multiple!: any; 
  @Prop({ default: "" }) value!: any; 
  @Prop({ default: "" }) filterPopperClass!: any; 
  
//#region 接口定义区

//#endregion 接口定义区


//#region 变量定义区

//#endregion 变量定义区


//#region 事件定义区
  mounted() {
    
  }

  get loadSelectValue(){
    return this.options.map(e=>e["value"])
  }

  onChange(value){
    this.ref("filterPoptip").handleClose()
    this.$emit('change',value)
  }


  getActive(value){
    if(Array.isArray(value)){
      return value.some(item=>{{
        return !this.isNull(item)
      }})
    }else{
      return !this.isNull(value)
    }


  }
//#endregion 事件定义区


//#region 方法定义区

//#endregion 方法定义区
}
